import React, { memo, useCallback } from "react";
import colors from "app/colors";
import { StrikethroughIcon } from "modules/icons";
import { IQuillFormats } from "modules/quill/use-quill";
import { Button } from "@chakra-ui/react";

interface IProps {
  format: (name: string, value: any) => void;
  activeFormats: IQuillFormats;
}

const ComposeQuillStrikethrough = ({ format, activeFormats }: IProps) => {
  const isSelected = !!activeFormats.strike;

  const onMouseDown = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      if (format) {
        format("strike", !isSelected);
      }
    },
    [isSelected, format],
  );

  const bg = isSelected ? colors.gray0 : colors.transparent;

  return (
    <Button
      variant="hover"
      size="sm"
      aria-label="Format text as strikethrough"
      tabIndex={-1}
      onMouseDown={onMouseDown}
      px={0}
    >
      <StrikethroughIcon
        boxSize={5}
        fill={colors.gray40}
        bg={bg}
        borderRadius={4}
      />
    </Button>
  );
};

export default memo(ComposeQuillStrikethrough);
